<template>
  <div style="line-height: 20px; overflow: auto; height: inherit;">
    <b>Kullanıcı => </b>{{ (params.data.b2BUserName==null ? "Tüm B2B ler" : params.data.b2BUserName) }} <br />
    <b>Ürün => </b>{{ params.data.productName }} <br /><b>Marka => </b>{{ params.data.brand }}<br /><b>İndirim Oranı => </b>{{ params.data.discountRate }} <br /><b>Süreli mi ? => </b
    >{{ params.data.isTimeLimited }}<br /><b>Date => </b>{{ params.data.date }} <br /><b>Başlangıç => </b>{{ params.data.start }} <br /><b>Bitiş => </b>{{ params.data.finish }}<br /><b>İndirim Türü => </b>{{ params.data.discountType }} <br /><b>İndirim Kapsamı => </b
    >{{ params.data.discountScope }}
  </div>
</template>

<script>
export default {
  name: "CellRendererDetail",
  data() {
    return {
      subscriptionList: "",
      span: "",
    };
  },
  computed: {},
  beforeMount() {},
};
</script>
